import { Badge } from '@/components/ui/badge';

interface SalesforceEntityTypeBadgeProps {
  /** Whether the SObject is a custom (user-defined) object. */
  isCustom: boolean;
}

/**
 * Displays a Salesforce SObject type (Standard or Custom) as an outline badge.
 * Custom objects have API names ending in __c.
 */
export function SalesforceEntityTypeBadge({ isCustom }: SalesforceEntityTypeBadgeProps) {
  return <Badge variant="outline">{isCustom ? 'Custom' : 'Standard'}</Badge>;
}
